(function ($) {
    function initCustomerMessage(selector) {
      var $textareas = $(selector);
      if (!$textareas.length) return;
  
      $textareas.each(function () {
        var $el = $(this);
  
        // remove maxlength if present
        $el.removeAttr('maxlength');
  
        // base styles
        $el.css({
          overflow: 'hidden',
          resize: 'none',
          height: '120px',
          maxHeight: '120px'
        });
  
        // adjust height
        var adjustHeight = function () {
          if ($el.val().trim() === '') {
            $el.css({ height: '120px', maxHeight: '120px' });
          } else {
            $el.css('height', 'auto');
            // use the DOM node to read scrollHeight
            var h = $el[0].scrollHeight;
            $el.css({ height: h + 'px', maxHeight: h + 'px' });
          }
        };
  
        // avoid duplicate handlers if re-initialized
        $el.off('input.autoResize').on('input.autoResize', adjustHeight);
  
        // initial call
        adjustHeight();
      });
    }
  
    // Run on DOM ready
    $(function () {
      initCustomerMessage('.customer-message');
    });
  
    // Re-run when CF7 initializes or after submit (form can be re-rendered)
    $(document).on('wpcf7init wpcf7mailsent', function () {
      initCustomerMessage('.customer-message');
    });
  })(jQuery);
  
  // jQuery(document).ready(function($) {
  //   $(window).on("scroll", function() {
  //     if ($(this).scrollTop() > 0) {
  //       $("#desktop-header").addClass("scrolled");
  //     } else {
  //       $("#desktop-header").removeClass("scrolled");
  //     }
  //   });
  // });